'use strict';

function Service($q) {

    let state = {};
    let subscriptions = [];

    const errorMessages = {
        dp: 'Down payment must be less than vehicle price.',
        ti: 'Trade-in value must be less than vehicle price.',
        dpti: 'Down payment + trade-in value must be less than the vehicle price.',
        tr: 'Must be from 0 to 100%',
        st: 'Must be from 0 to 100%',
        vp: 'Enter a vehicle price.',
        dpInvalid: 'Enter numbers only',
        irInvalid: 'Enter numbers only',
        stInvalid: 'Enter numbers only',
        tiInvalid: 'Enter numbers only',
        vpInvalid: 'Enter numbers only',

    };

    function get(key) {
        return state[key];
    }

    function subscribe(method) {
        if (typeof method === 'function') {
            subscriptions.push(method);
        }
    }

    function calculatePayment (form) {
        return validateInput(form).then(data => doMath(data));
    }

    function validateInput(form) {
        const formData = parseAllItemsAsNumbers(form);
        return validateFormData(formData);
    }

    function validateFormData(formData) {
        if (formData.error) {
            return $q.reject({
                code: formData.error
            });
        }

        const itemsInForm = Object.keys(formData).filter(key => formData[key] || formData[key] === 0);
        const requiredItems = ['months', 'rate', 'cost', 'down', 'tradein', 'tax'];
        const missingItems = requiredItems.filter(item => itemsInForm.indexOf(item) === -1);
        const invalidValues = itemsInForm.filter(key => formData[key] != formData[key]);

        const invalidTaxRate = formData.rate > 100.0;
        const invalidSalesTax = formData.tax > 100.0;

        let code;

        if (formData.cost && !(formData.cost >= 0)) {

            code = 'vp';
            return $q.reject({
                code
            });

        } else if (formData.down + formData.tradein > formData.cost) {

            if (!formData.down) {
                code = 'ti';
            } else if (!formData.tradein) {
                code = 'dp';
            } else {
                code = 'dpti';
            }
            return $q.reject({
                code
            });

        } else if (invalidTaxRate || invalidSalesTax) {

            if (invalidTaxRate) {
                code = 'tr';
            } else {
                code = 'st';
            }
            return $q.reject({
                code
            });

        } else if (missingItems.length) {
            return $q.reject({
                missingItems
            });
        } else if (invalidValues.length) {
            return $q.reject({
                invalidValues
            });
        } else {
            return $q.resolve(formData);
        }
    }

    function parseAllItemsAsNumbers(obj) {
        const parsed = {};
        let code, parsedValue, inputLetters, formValue;

        Object.keys(obj).forEach((k) => {
            inputLetters = String(obj[k]).replace(/[0-9\.$%]/g, '');
            parsedValue = parseFloat(obj[k], 10);
            formValue = String(obj[k]).replace(/[$%]/g, '');

            if (isNaN(parsedValue) || inputLetters.length > 0) {
                switch (k) {
                    case 'cost':
                        if (!(formValue >= 0)) {
                            code = 'vpInvalid';
                        } else {
                            code = 'vp';
                        }
                        break;
                    case 'down':
                        code = 'dpInvalid';
                        break;
                    case 'tradein':
                        code = 'tiInvalid';
                        break;
                    case 'tax':
                        code = 'stInvalid';
                        break;
                    case 'rate':
                        code = 'irInvalid';
                        break;
                }
            }
            parsed[k] = parsedValue;
        });

        if (code) {
            return {
                error: code
            };
        } else {
            return parsed;
        }
    }

    function doMath(formData) {
        const {
            months,
            rate,
            cost,
            down,
            tradein,
            tax
        } = formData;
        const years = months / 12;
        const apr = rate / 100;
        const taxRate = tax / 100;
        const principal = cost + (cost * taxRate) - down - tradein;
        const numerator = apr * principal;
        const denominator = 1 - Math.pow((1 + apr), (0 - years));
        const annualPayment = numerator / denominator;
        const monthlyPayment = annualPayment / 12;
        const payment = rate ? parseInt(monthlyPayment, 10) : Math.round(principal / months);
        state = formData;
        state.payment = payment;
        subscriptions.forEach(subscription => {
            subscription();
        });
        return $q.resolve({
            monthly: payment
        });
    }

    return { calculatePayment, validateInput, errorMessages, get, subscribe };
}

Service.$inject = ['$q'];

export default Service;
